import { VictoryPie } from 'victory';
import tailwindConfig from '../../../tailwind.config';

export default function PercentageDonut({ positivePercentage, label }: { positivePercentage: number, label: string }) {
  const colours = tailwindConfig.theme.extend.colors;
  return (
    <div className="relative w-[88px] h-[88px] shrink-0">
      <VictoryPie
        data={[
          { x: 'positive', y: positivePercentage },
          { x: 'remaining', y: 100 - positivePercentage },
        ]}
        innerRadius={150}
        cornerRadius={30}
        padding={0}
        labels={() => null}
        style={{
          data: {
            fill: ({ datum }) => (datum.x === 'positive' ? colours.primary.DEFAULT : colours.pipbg.grouped),
          },
        }}
      />
      <span className="absolute inset-0 flex items-center justify-center text-2xl font-semibold text-primary">
        {label}
      </span>
    </div>
  );
}
